export default __webpack_public_path__ + "static/media/iconmonstr-instagram-11.6ed2cb52.svg";